//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["searchVar","type","name","attrName","defaultValue","logicalOperation","mathOperation","lov"],"AddFieldDescription",{},8,1]],[]];
SPLM.PDM.SoaQuery = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.SoaQuery";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PdmSoaqueryNxmgrfielddatatype = Object.freeze({
    "Char" : "Char", "Date" : "Date", "Double" : "Double", "Float" : "Float", "Int" : "Int", "Bool" : "Bool", "Short" : "Short", "String" : "String", "Reference" : "Reference", "UntypedReference" : "UntypedReference", "ExternalReference" : "ExternalReference"});

export default SPLM;